import { PayloadAction } from "@reduxjs/toolkit";
import { ClientsState } from "../../models/ClientsState";
import { GetClientStatisticsForVendorPayload } from "../../payload/GetClientStatisticsForVendor/GetClientStatisticsForVendorPayload";

const getClientStatisticsForVendorFetch = (state: ClientsState, actions: PayloadAction<GetClientStatisticsForVendorPayload>) => {
    state.isLoading = true;
}

export default getClientStatisticsForVendorFetch;